import { UpsertEntitiesFailure } from '@evidentid/rpweb-api-client/models';

const MAX_LISTED_FAILURES = 5;

// A validation detail opens with a JSON pointer into the request element, followed by a colon when the
// message reads on its own (`#/producerList/0/email: ...`) or without one when the field is its subject
// (`#/producerList/0/contactName must not be empty`).
const DETAIL_PATTERN = /^#\/(\S*?)(:?)\s+(.*)$/;

function describeDetail(detail: string): string {
    const match = DETAIL_PATTERN.exec(detail);
    if (!match) {
        return detail;
    }
    const [ , path, colon, message ] = match;
    return colon ? message : `${path.split('/').pop()} ${message}`;
}

/** One line per refused entity, saying why, for the few the dashboard has room to list. */
export function describeImportFailures(failures: UpsertEntitiesFailure[]): string[] {
    const lines = failures.slice(0, MAX_LISTED_FAILURES).map(({ element, error }) => {
        const name = element?.displayName || element?.contactEmail;
        const detail = error?.details?.[0];
        return `${name}: ${detail ? describeDetail(detail) : error?.message}`;
    });
    const remaining = failures.length - MAX_LISTED_FAILURES;
    return remaining > 0 ? [ ...lines, `And ${remaining} more.` ] : lines;
}
